import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from '@/components/navbar';

export const DefaultLayout: FC = () => {
  return (
    <div className="flex flex-col min-h-screen w-full">
      <Navbar />
      <Outlet />
    </div>
  );
};
